//mui
import {Theme} from '@mui/material';

export const MuiPaper = {
	styleOverrides: {
		root: ({theme}: {theme: Theme}) => {
			return {
				boxShadow: 'var(--box-shadow--2)',
				borderRadius: 'var(--default--border-radius)',
				marginTop: 4,
				overflow: 'hidden',

				'& .MuiList-root .MuiMenuItem-root': {
					height: 40,
					'&:hover': {
						backgroundColor: `${theme.palette.primary100} !important`,
					},
					'&:focus': {
						backgroundColor: 'unset',
					},
					'& span > span': {
						display: 'none',
					},

					'&.MuiMenuItem-gutters.Mui-selected': {
						backgroundColor: 'unset',
					},
				},
				'& .MuiDateCalendar-root': {
					maxWidth: 340,

					' .MuiPickersCalendarHeader-root': {
						padding: 'unset',
						margin: 24,
						' .MuiPickersCalendarHeader-labelContainer': {
							margin: '0 auto',
						},
						' .MuiPickersArrowSwitcher-root': {
							width: 0,

							' .MuiIconButton-edgeEnd': {
								position: 'absolute !important',
								left: 24,
								top: 24,
							},
							' .MuiIconButton-edgeStart': {
								position: 'absolute',
								right: 24,
								top: 24,
							},
						},
					},
					'& .MuiPickersDay-root': {
						'&.Mui-selected': {
							backgroundColor: `${theme.palette.primary500}`,
						},
						'&.MuiPickersDay-today': {
							backgroundColor: 'unset',
						},

						'&.Mui-selected.MuiPickersDay-today': {
							backgroundColor: `${theme.palette.primary500}`,
						},
					},
				},
				'& .MuiPickersYear-root .Mui-selected': {
					backgroundColor: `${theme.palette.primary500}`,
					':focus': {
						backgroundColor: `${theme.palette.primary500}`,
					},
				},
			};
		},
	},
};
